module.exports = __webpack_public_path__ + "img/0120.2d24aaf4.jpg";